import React, { useEffect, useState } from 'react';
import { Button, Grid, IconButton } from '@material-ui/core';
import { useTranslation } from "react-i18next";
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import { RepLIProviderTextField } from '../../../components';
import { AppSelect } from './ProviderInputComponents';
import { arrayOfNumbers } from '../../../services/util.service';

import useStyles from "./Common.style";

const PatientChildrenDeathInformationForm = props => {
    const classes = useStyles();
    const { t } = useTranslation();

    const [autoUpdate, setAutoUpdate] = useState(false);

    let birthYear = new Date(props.dateOfBirth).getFullYear();
    let firstPeriodAge = parseInt(props.firstPeriodAge);
    let firstPeriodYear = firstPeriodAge ? birthYear + firstPeriodAge : null;
    let currentYear = new Date(Date.now()).getFullYear();
    let lossYears = firstPeriodYear
        ? [...arrayOfNumbers(firstPeriodYear, currentYear - firstPeriodYear + 1)]
        : [];

    useEffect(() => {
        if (props.submitted) props.validator.showMessages();
        props.validator.purgeFields();
        setAutoUpdate(!autoUpdate);
    }, [props.submitted, props.validator, props.childrenDeath]);

    return (
        <Grid container className={classes.questionnaireContainer}>
            {props.childrenDeath.map((childrenDeath, i) => {
                return (
                    <Grid key={i} container spacing={1} className={classes.questionnaireItem}>
                        <Grid item xs={12} className={classes.questionnaireItemHeader}>
                            <span>{t('repliQuestionnaire.label.childrenLoss')} #{i + 1}</span>
                            <IconButton aria-label="delete" color="inherit" onClick={props.onChildrenDeathDelete(i)}>
                                <DeleteIcon />
                            </IconButton>
                        </Grid>
                        <Grid item xl={4} md={6} className={classes.appSelectGridItem}>
                            <AppSelect
                                id={`loss${i + 1}`}
                                label={`${t('common.substantive.year')}*`}
                                value={childrenDeath.year}
                                items={lossYears}
                                onChange={props.onDataChange(i, 'year')}
                                fullWidth
                                error={props.submitted && !props.validator.fieldValid(`children_loss_#${i + 1}_year`)}
                                helperText={props.validator.message(`children_loss_#${i + 1}_year`, childrenDeath.year, 'required')}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <RepLIProviderTextField
                                label={`# ${t('repliQuestionnaire.label.childrenLoss')}*`}
                                type="number"
                                min="0"
                                value={childrenDeath.childrenQty && Math.max(0, childrenDeath.childrenQty)}
                                onChange={props.onDataChange(i, 'childrenQty')}
                                error={props.submitted && !props.validator.fieldValid(`children_loss_#${i + 1}`)}
                                helperText={props.validator.message(`children_loss_#${i + 1}`, childrenDeath.childrenQty, 'required|numeric|min:0,num')}
                            />
                        </Grid>
                    </Grid>
                )
            })}
            <Grid item xs={12}>
                <Button
                    fullWidth
                    variant="contained"
                    color="secondary"
                    startIcon={<AddIcon />}
                    onClick={props.onChildrenDeathAdd}
                >
                    {t('repliQuestionnaire.label.addChildrenDeath')}
                </Button>
            </Grid>
        </Grid>
    )
};

export default PatientChildrenDeathInformationForm;